<template>
  <v-dialog
    v-model="isShowDialog"
    :value="showDialog"
    :width="width"
    :fullscreen="fullscreen"
    persistent
    :scrollable="scrollable"
  >
    <v-card dark>
      <v-card-title>
        {{ $t('titulos.messageDialog') }}
      </v-card-title>
      <v-card-text>
        <p
          v-for="(msg, index) in message"
          :class="`${verifyErrorText(msg)} subtitle-1 white--text`"
          :key="index"
        >
          {{ msg }}
        </p>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="blue darken-4"
          class="text-overline"
          @click="$emit('close')"
          >OK</v-btn
        >
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex'
export default {
  props: {
    'show-dialog': {
      type: Boolean,
      required: true,
    },
    width: {
      default: 500,
    },
    fullscreen: {
      type: Boolean,
      default: false,
    },
    scrollable: {
      type: Boolean,
      required: false,
    },
    value: {
      type: Boolean,
      required: false,
    },
    colorClass: {
      type: String,
      required: false,
      default: 'white--text',
    },
    message: {
      type: Array,
      required: true,
    },
  },
  computed: {
    ...mapState('authModule', ['tokenInvalid']),
    isShowDialog: {
      get() {
        return this.tokenInvalid ? false : this.showDialog
      },
      set() {
        this.showDialog = this.value
      },
    },
    textColor() {
      if (this.colorClass != '') return this.colorClass
      else return 'white--text'
    },
  },
  methods: {
    verifyErrorText(text) {
      return text.lastIndexOf('[ERROR]') != -1 ? 'warning' : ''
    },
  },
}
</script>

<style></style>
